import React, { useState, useContext } from 'react';

const PostInfoContext = React.createContext({});

export const usePostInfo = () => useContext(PostInfoContext);

const PostInfoProvider = ({ children }) => {
  const postInfoState = {
    postData: {},
    updatePostCategory: postData => setPostInfo({ ...postInfo, postData }),
  };
  const [postInfo, setPostInfo] = useState(postInfoState);
  return <PostInfoContext.Provider value={postInfo}>{children}</PostInfoContext.Provider>;
};

export { PostInfoProvider, PostInfoContext };
